import { useState } from 'react';
import {
  Table, TableRow, TableCell, TableHead, TableBody,
} from '@mui/material';
import { useEffectAsync } from '../reactHelper';
import { useTranslation } from '../common/components/LocalizationProvider';
import { formatBoolean } from '../common/util/formatter';
import { prefixString } from '../common/util/stringUtils';
import PageLayout from '../common/components/PageLayout';
import SettingsMenu from './components/SettingsMenu';
import CollectionFab from './components/CollectionFab';
import CollectionActions from './components/CollectionActions';
import TableShimmer from '../common/components/TableShimmer';
import SearchHeader, { filterByKeyword } from './components/SearchHeader';
import { useRestriction } from '../common/util/permissions';
import useSettingsStyles from './common/useSettingsStyles';
import DataTable from '../common/components/Datatable';
import fetchOrThrow from '../common/util/fetchOrThrow';

const CommandsPage = () => {
  const { classes } = useSettingsStyles();
  const t = useTranslation();

  const [timestamp, setTimestamp] = useState(Date.now());
  const [items, setItems] = useState([]);
  const [searchKeyword, setSearchKeyword] = useState('');
  const [loading, setLoading] = useState(false);
  const limitCommands = useRestriction('limitCommands');

  useEffectAsync(async () => {
    setLoading(true);
    try {
      const response = await fetchOrThrow('/api/commands');
      setItems(await response.json());
    } finally {
      setLoading(false);
    }
  }, [timestamp]);

  const columns = [
    { field: 'id', headerName: 'ID', width: 80, disableColumnMenu: true },
    { field: 'description', headerName: t('sharedDescription'), flex: 1, disableColumnMenu: true },
    {
      field: 'type',
      headerName: t('sharedType'),
      flex: 1,
      disableColumnMenu: true,
      renderCell: (params) => {
        if (!params || !params.value) return '';

        // Usar o prefixString para garantir o formato correto da chave de tradução
        const translationKey = prefixString('command', params.value);
        return t(translationKey);
      },
    },
    {
      field: 'textChannel',
      headerName: t('commandSendSms'),
      flex: 1,
      disableColumnMenu: true,
      renderCell: (params) => formatBoolean(params.value, t),
    },
    {
      field: 'actions',
      headerName: t('actions'),
      sortable: false,
      renderCell: (params) => (
        <div>
          <CollectionActions itemId={params.row.id} editPath="/settings/command" endpoint="commands" setTimestamp={setTimestamp} />
        </div>
      ),
      width: 150,  // Set a fixed width for the actions column
      disableColumnMenu: true,
      hide: limitCommands
    }
  ];

  return (
    <PageLayout menu={<SettingsMenu />} breadcrumbs={['settingsTitle', 'sharedSavedCommands']}>
      <DataTable
        tableName='sharedSavedCommands'
        columns={columns}
        rows={items}
        loading={loading}
        getRowId={(row) => row.id}
      />
      <CollectionFab editPath="/settings/command" disabled={limitCommands} />
    </PageLayout>
  );
};

export default CommandsPage;
